import type { ContentObject } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useContentObjectModalTitle = ({ title, type }: { title: string; type: ContentObject['type'] }) => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      type === 'event'
        ? t('{{name}}s event', {
            name: title,
          })
        : t('{{name}}s post', {
            name: title,
          }),
    [t, title, type],
  );
};
